import type { StudentNoteItem } from './orchestrator';
import type { StudentClassification } from './studentClassification';
import type { ProjectIdentity } from './project';
import type { ActiveSubscriptionPause } from './subscription';

export type PerformanceWorkoutStatus = 'scheduled' | 'delivered' | 'paused';

export interface PerformanceRow {
  id: number;
  student_id: number;
  student_name: string;
  student_email: string | null;
  competence: string;
  previous_competence: string;
  previous_workout_code: string;
  current_training_code: string | null;
  next_training_code: string | null;
  expected_delivery_date: string | null;
  days_until_expected_delivery?: number | null;
  delivered_at: string | null;
  delivered_by_portal_user_id: number | null;
  coach_id: number | null;
  coach_name: string | null;
  classification?: StudentClassification;
  project: ProjectIdentity | null;
  is_reactivated: boolean;
  is_sensitive?: boolean;
  sensitive_reason?: string | null;
  is_pregnant?: boolean;
  pregnant_until?: string | null;
  is_red_flag?: boolean;
  performance_support_reason?: string | null;
  student_phone_country_code?: string | null;
  student_phone_number?: string | null;
  status: PerformanceWorkoutStatus;
  active_pause: ActiveSubscriptionPause | null;
  notes: string | null;
  student_notes: StudentNoteItem[];
  notes_summary: string | null;
  has_fup_response: boolean;
  student_fup_id?: number | null;
  workout_history_id: number | null;
  last_workout_date: string | null;
  history_workout_code: string | null;
  created_at: string;
  updated_at: string;
}

export const PERFORMANCE_STATUS_LABELS: Record<PerformanceWorkoutStatus, string> = {
  scheduled: 'Pendente de entrega',
  delivered: 'Treino entregue',
  paused: 'Assinatura pausada',
};

export const PERFORMANCE_STATUS_OPTIONS = [
  { value: 'scheduled' as const, label: 'Pendente de entrega' },
  { value: 'delivered' as const, label: 'Entregue' },
];

export interface PerformanceFilters {
  search?: string;
  coachIds?: string[];
  statuses?: string[];
  filterStudentTenure?: string;
  classifications?: string[];
  projectCodes?: string[];
  competence?: string;
  /** @deprecated use expectedDeliveryDateStart */
  dateStart?: string;
  /** @deprecated use expectedDeliveryDateEnd */
  dateEnd?: string;
  expectedDeliveryDateStart?: string;
  expectedDeliveryDateEnd?: string;
  deliveredDateStart?: string;
  deliveredDateEnd?: string;
  sortOrder?: 'asc' | 'desc';
}
